import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { MALL_DEFAULT_PAGE_SIZE } from '@/constants/mall'

// Types

interface ICategory {
  categoryId: number
  name: string
  nextPageSize?: string
}

interface IParams {
  fetchDataApi: any
  testMode?: string
  categoryFilterSSR?: ICategory[]
  categoryListDataSSR?: {
    productsInfo: {
      categoryId: number
      categoryName: string
      currency: string
      dummySalesVolume: number
      images: string[]
      logistics: string[]
      maxLivePrice: number
      maxPrice: number
      merchantId: number
      merchantName: string
      minLivePrice: number
      minPrice: number
      offShelfDate: string
      onShelfDate: string
      origPrice: number
      productDesc: string
      productDetail: string
      productId: number
      productName: string
      saleQuantity: number
      shippingDays: number
      status: number
      tags: null
      taxType: number
      temperature: string
    }[]
  }
}

export const useMallList = ({ fetchDataApi }: IParams) => {
  const router = useRouter()
  const categoryId = Number(router.query.category_id) || Number(router.query.category) || -1

  const { query } = router
  const { order = '', sortBy = '' } = query

  const categoryListData = useInfiniteQuery(
    [QUERY_KEY.FETCH_CATEGORY_LIST, { categoryId, order, sortBy }],
    ({ pageParam }) =>
      fetchDataApi(categoryId, {
        pageSize: MALL_DEFAULT_PAGE_SIZE,
        pageNo: pageParam,
        sortBy,
        order,
      }),
    {
      enabled: !!categoryId && router.isReady && !!sortBy,
      staleTime: Infinity,
      getNextPageParam: (lastPage, pages) => {
        if (!router.isReady || !categoryId) return undefined
        const currentPage = pages?.length || 1
        const totalPage = lastPage?.totalPage?.totalPages || 0
        let result: number | undefined = 0
        const allPageData = JSON.stringify({ data: pages })
        const emptyPageDataIdentifier = '"productsInfo":null'

        if (allPageData.includes(emptyPageDataIdentifier)) {
          result = undefined
          return
        }

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          const isLastPage = currentPage === totalPage
          result = isLastPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  )

  return { categoryListData }
}
